import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
} from "@angular/core";

@Directive({
  selector: "[clickOutside]",
})
export class ClickOutsideDirective implements OnInit {
  @Output() clickOutsideDatepicker = new EventEmitter<any>();

  constructor(private elementRef: ElementRef) {}
  ngOnInit(): void {}

  @HostListener("document:click", ["$event.target"])
  public onClick(targetElement: EventTarget) {
    const clickOutside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickOutside) {
      this.clickOutsideDatepicker.emit();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/date-picker/click-outside.directive.ts